// @flow
import { connect } from 'react-redux';
import type { State } from '../../modules/reducers';
import { GenericLogin } from '../../components/common';
import type { DispatchProps, StateProps } from '../../components/common/GenericLogin';
import { loginDuringSignUp } from '../../modules/Authentication/actions';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';

const mapStateToProps = (state: State): StateProps => ({
  isLoading: isLoadingSelector(state, 'loginDuringSignUp'),
  disableCreateAccount: true, // user will click on Back
});

const mapDispatchToProps: DispatchProps = {
  onSubmit: loginDuringSignUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(GenericLogin);
